export const GET_CALENDAR_SUCCESS = 'GET_CALENDAR_SUCCESS';
export const GET_MULTIPLE_CALENDARS_SUCCESS = 'GET_MULTIPLE_CALENDARS_SUCCESS';
export const UPDATE_CALENDAR_SUCCESS = 'UPDATE_CALENDAR_SUCCESS';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
